var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconTrashGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 5.83333L15.1108 15.9517C15.0808 16.3722 14.8927 16.7657 14.5842 17.053C14.2757 17.3403 13.8698 17.5 13.4483 17.5H6.55159C6.13004 17.5 5.72414 17.3403 5.41566 17.053C5.10717 16.7657 4.91902 16.3722 4.88909 15.9517L4.16659 5.83333M8.33325 9.16667V14.1667M11.6666 9.16667V14.1667M12.4999 5.83333V3.33333C12.4999 3.11232 12.4121 2.90036 12.2558 2.74408C12.0996 2.5878 11.8876 2.5 11.6666 2.5H8.33325C8.11224 2.5 7.90028 2.5878 7.744 2.74408C7.58772 2.90036 7.49992 3.11232 7.49992 3.33333V5.83333M3.33325 5.83333H16.6666",
    stroke: "#8C8E90",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconTrashGrey);
export default __webpack_public_path__ + "static/media/common_icon_trash_grey.14d92ecf1b7851f8fc40c1090bd3f5b2.svg";
export { ForwardRef as ReactComponent };